import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { Obra } from '@/types';
import { Sheet } from '@/components/ui/Sheet';

interface Props {
  open: boolean;
  obra?: Obra | null;
  busy?: boolean;
  onClose: () => void;
  onSave: (input: { nome: string; centroCusto: string | null }) => void;
}

export function ObraSheet({ open, obra, busy, onClose, onSave }: Props) {
  const { t } = useTranslation();
  const [nome, setNome] = useState('');
  const [centroCusto, setCentroCusto] = useState('');

  useEffect(() => {
    if (!open) return;
    setNome(obra?.nome ?? '');
    setCentroCusto(obra?.centroCusto ?? '');
  }, [open, obra]);

  return (
    <Sheet open={open} onClose={onClose} title={obra ? t('common.edit') : t('sheet.novaObra')}>
      <div className="label-eyebrow">{t('sheet.designacao')}</div>
      <input
        className="field mt-2 bg-[#fbfbfd] text-[13px]"
        placeholder={t('sheet.designacaoPlaceholder')}
        value={nome}
        maxLength={200}
        onChange={(e) => setNome(e.target.value)}
      />

      <div className="label-eyebrow mt-4">{t('sheet.centroCusto')}</div>
      <input
        className="field num mt-2 bg-[#fbfbfd] text-[13px]"
        placeholder={t('sheet.centroCustoPlaceholder')}
        value={centroCusto}
        maxLength={60}
        onChange={(e) => setCentroCusto(e.target.value)}
      />

      <button
        type="button"
        disabled={!nome.trim() || busy}
        onClick={() => onSave({ nome: nome.trim(), centroCusto: centroCusto.trim() || null })}
        className="btn-primary mt-6"
      >
        {obra ? t('common.save') : t('sheet.guardarObra')}
      </button>
    </Sheet>
  );
}
